var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('home-hero'),_c('main',{attrs:{"id":"main"}},[_c('hr'),_c('home-featured-services'),_c('hr'),_c('home-cta'),_c('hr'),_c('contact-form')],1),_c('ks-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }